/**
 * Scrolls to a playlist anchor on My Library (community profile).
 * Matches CommunityMyLibraryNav: waits for paint and offsets sticky collections controls.
 */
export default function scrollToPlaylistSection (elementId: string) {
  requestAnimationFrame(() => {
    const el = document.getElementById(elementId)
    if (!el) return

    const stickyHeader = document.querySelector('.playlist-tab-container__sticky-controls')
    const stickyHeight = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0
    const padding = 16
    const top = el.getBoundingClientRect().top + window.scrollY - stickyHeight - padding

    window.scrollTo({ top, behavior: 'smooth' })
  })
}
